export const CUSTOM_VIDEO_COMMAND_NAME = 'customAddVideo';
export const CUSTOM_IMAGE_COMMAND_NAME = 'customAddImage';
export const IMAGE_EDIT_COMMAND_NAME = 'editImage';
export const IMAGE_EDIT_MARGINS_COMMAND_NAME = 'editImageMargins';
export const ELEMENT_INSERT_COMMAND_NAME = 'elementInsert';
export const CUSTOM_AUDIO_COMMAND_NAME = 'customAddAudio';
export const EQUATION_COMMAND_NAME = 'equationInsert';
